import { delegate, lockScroll, unlockScroll } from '../tools';

/**
 * Main nav states.
 */
class MainNav {
    /**
     * Construct.
     */
    constructor() {
        this.mainNav = document.querySelector('.l-header .l-header__nav .main-nav');

        if (!this.mainNav) {
            return;
        }

        this.navContainer = this.mainNav.closest('.l-header__nav');

        document.addEventListener('click', delegate('[data-main-nav-toggle]', () => this.toggle()));

        this.levelOneItems = this.mainNav.querySelectorAll('.main-nav__item');

        this.levelOneItems.forEach(el => {
            el.addEventListener('mouseenter', e => this.mouseEnterListener(e));
            el.addEventListener('mouseleave', e => this.mouseLeaveListener(e));
        });

        this.header = this.mainNav.closest('.l-header');
    }

    /**
     * Toggle main navigation.
     */
    toggle() {
        this.navContainer.classList.toggle('l-header__nav--is-open');

        /**
         * After close listener.
         * @param e
         */
        const afterClose = () => {
            unlockScroll();

            this.navContainer.removeEventListener('transitionend', afterClose);
        };

        if (this.navContainer.matches('.l-header__nav--is-open')) {
            lockScroll();
        } else {
            this.navContainer.addEventListener('transitionend', afterClose);
        }
    }

    /**
     * Listen for mouse enter.
     * @param e
     */
    mouseEnterListener() {
        let height = Math.max(...Array.from(this.levelOneItems).map(el => {
            const subitem = el.querySelector('.level_2');

            return subitem ? subitem.scrollHeight : 0;
        }));

        this.header.classList.add('l-header--nav-hover');
        this.header.style.setProperty('--nav-height', `${height}px`);
    }

    /**
     * Listen for mouse leave.
     */
    mouseLeaveListener() {
        this.header.classList.remove('l-header--nav-hover');
    }
}

export default MainNav;
